import * as React from 'react'

interface Props {
  text: string
}

export function MultiLineText({ text }: Props) {
  if (text === null) {
    return <></>
  }

  const array = text.split('\n')
  const n = array.length
  return (
    <>
      {array.map((line, i) =>
        i === n - 1 ? (
          <React.Fragment key={i}>{line}</React.Fragment>
        ) : (
          <React.Fragment key={i}>
            {line}
            <br />
          </React.Fragment>
        ),
      )}
    </>
  )
}
